/**
 * Transforms a single community item to the GraphQL node format
 */
export function mapCommunityToNode(item) {
    return {
        id: item.id,
        data: item.data,
        type: item.type,
        ctime: item.ctime,
        utime: item.utime,
        sequence: item.sequence ?? 0,
    };
}
/**
 * Transforms a paginated list of communities to the GraphQL format
 */
export function mapPaginatedCommunities(result) {
    return {
        totalCount: result?.totalCount ?? 0,
        list: result?.list.map(mapCommunityToNode) ?? [],
    };
}
